import { useTranslation } from 'react-i18next'

import { QA_NAME_ATTACH_BTN } from '../../../constants/qa'
import Button from '../../Button'
import { FileUpload } from '../../File'

import AttachIcon from '../../../icons/attach.svg'

/*
  req props onFinishUpload, onStartUpload, onUploadErrors
 */

function FormUploadAction({
  disabled,
  title = 'Modal.AttachBtnKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <FileUpload {...restProps}>
      <Button.Text
        beforeIconProps={{ Icon: AttachIcon }}
        disabled={disabled}
        qaName={QA_NAME_ATTACH_BTN}
        text={t(title)}
        type='button'
      />
    </FileUpload>
  )
}

export default FormUploadAction
